//
//  SDKComponentResolver.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { Component, } from "../../model/components/SDKComponent";
import { sortUsingMap, sureOf } from "../../utils/CommonUtils";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class ComponentResolver {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Configuration
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Resolution
    resolveComponentData(components, elementProperties, elementValues, elementViews) {
        // Sort properties using views
        const firstView = sureOf(elementViews.find((v) => v.isDefault));
        const indexes = new Map();
        firstView.columns.forEach((column) => {
            if (column.propertyDefinitionId) {
                indexes.set(column.propertyDefinitionId, firstView.columns.indexOf(column));
            }
        });
        const sortedProperties = sortUsingMap(elementProperties, indexes, (p) => p.id);
        // Resolve components
        const resolvedComponents = components.map((c) => new Component(c, sortedProperties, elementValues));
        return resolvedComponents;
    }
}
